const getLocalStorageIfAvailable = (name) => {
  if (typeof window !== `undefined` && !!localStorage.getItem(name)) {
    // console.log("getLocalStorageIfAvailable")
    return localStorage.getItem(name)
  }
  return null
}

const defaultState = {
  currentChannel: getLocalStorageIfAvailable("channel") || "",
  brandedContent: [],
  searchResults: [],
  query: "",
  expanded: false,
  logoVisible: true,
  searchVisible: true,
  modalVisible: false,
  modalMessage: {},
}

export const modalVisibleReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SHOW_MODAL_WITH_MESSAGE":
      return { ...state, modalVisible: true, modalMessage: action.payload }
    case "HIDE_MODAL":
      return { ...state, modalVisible: false }
    default:
      return state
  }
}

export const channelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CHANGE_CHANNEL":
      return { ...state, currentChannel: action.payload }
    default:
      return state
  }
}

export const brandedContentReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "ADD_BRANDED_CONTENT":
      return {
        ...state,
        brandedContent: [...state.brandedContent, ...action.payload],
      }
    default:
      return state
  }
}

export const searchResultsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_RESULTS":
      const newResults = action.payload.filter(
        (result) => state.searchResults.indexOf(result) === -1
      )
      return newResults.length
        ? { ...state, searchResults: [...state.searchResults, ...newResults] }
        : { ...state, searchResults: [] }
    case "CLEAR_RESULTS":
      return { ...state, searchResults: [] }
    default:
      return state
  }
}

export const queryReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_QUERY":
      return { ...state, query: action.payload }
    default:
      return state
  }
}

export const searchBarExpandedReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TOGGLE_EXPANDED":
      return { ...state, expanded: action.payload }
    default:
      return state
  }
}

export const logoVisibleReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TOGGLE_LOGO_VISIBLE":
      return { ...state, logoVisible: action.payload }
    default:
      return state
  }
}

export const searchVisibleReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TOGGLE_SEARCH_VISIBLE":
      return { ...state, searchVisible: action.payload }
    default:
      return state
  }
}
